import { APIData, appFetch } from ".";

export const branchesAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Branch[]>>("/branches?page=" + page)
  },
};
